// @ts-expect-error
export const isE2ETest = !!window.Cypress;